<template>
  <component
    :is="mode"
    v-bind="$attrs"
    ref="luckyWheel"
    @start="$emit('start')"
    @end="(prize)=>$emit('end', prize)"
    @rotating="$emit('rotating')"
    @clickPrize="(item)=>$emit('clickPrize', item)"
  >
    <template #prize="{item,index}">
      <slot
        name="prize"
        :item="item"
        :index="index"
      ></slot>
    </template>
    <template #pointer>
      <slot name="pointer">
      </slot>
    </template>
  </component>
</template>

<script>
import RotateHighlight from './components/rotate-highlight'
import RotateTurntable from './components/rotate-turntable'
import RotatePointer from './components/rotate-pointer'
import NineGrid from './components/nine-grid'
export default {
  name: 'LuckyLottery',
  components: {
    RotateHighlight,
    RotateTurntable,
    RotatePointer,
    NineGrid,
  },
  props: {
    mode: {
      type: String,
      default: 'RotateTurntable',
    },
  },
  methods: {
    pick(index, endCallback) {
      this.$refs.luckyWheel.pick(index, endCallback)
    },
    play() {
      this.$refs.luckyWheel.play()
    },
    reset() {
      this.$refs.luckyWheel.reset()
    },
  },
}
</script>
